<div [ngClass]="cssMenuItem" [style.margin-left.px]="marginLeftPx">
    <a
        class="lg-sidebar-menu-item--link"
        [href]="navNode.getHref()"
        (click)="onClick($event)"
        (contextmenu)="onContextMenu($event)"
        [attr.tabIndex]="navNode.disabled ? null : 0"
        #toggleLink
    >
        {{ (navNode.namePrefix || "") + navNode.name }}
        @if (!hasChildren()) {
            <lg-icon icon="icon-used-arrow" />
        }
    </a>
    @if (hasToggle()) {
        <a
            class="lg-sidebar-menu-item--toggle"
            [class.expanded]="isExpanded()"
            (click)="onToggle()"
        >
            <lg-icon icon="icon-arrow-down" />
        </a>
    }
</div>
@if (isExpanded()) {
    @for (child of navNode.children ?? []; track $index) {
        <lg-sidebar-menu-item
            [currentUrl]="currentUrl"
            [navNode]="child"
            [matchChildrenByQueryParams]="matchChildrenByQueryParams"
            [level]="level + 1"
            [sidebar]="sidebar"
            (navigate)="navigate.emit($event)"
        />
    }
}
@if (hasDivider()) {
    <div class="lg-sidebar-menu-item--divider"></div>
}
